<template>
    <a-layout-sider width="160" class="sider" style="background-color: #38A9E1" :collapsed="collapsed" :trigger="null" collapsible>
        <div class="menu-wrapper">
            <div class="top-menu">
                <a-menu mode="inline" overflowedIndicator :inline-collapsed="collapsed" style="background-color: #38A9E1" v-model:selectedKeys="selectedKeys">
                    <a-menu-item v-if="!menu.hidden" v-for="menu in menus" :key="menu.path" @click="onMenuTappped(menu)">
                        <div style="display: flex; align-items:center;">
                            <span class="anticon">
                                <svg-icon :icon-class="menu.meta.icon" class="svg-icon_menu" />
                            </span>
                            <span>{{ menu.meta.name }}</span>
                        </div>
                    </a-menu-item>
                </a-menu>
            </div>
            <div class="bottom-menu">
                <a-menu  overflowedIndicator :inline-collapsed="collapsed" style="background-color: #38A9E1" v-model:selectedKeys="selectedKeys">
                    <a-menu-item v-if="!menu.hidden" v-for="menu in bottomMenus" :key="menu.path" @click="onMenuTappped(menu)">
                        <div style="display: flex; align-items:center;">
                            <span class="anticon">
                                <svg-icon :icon-class="menu.meta.icon" class="svg-icon_menu" />
                            </span>
                            <span>{{ menu.meta.name }}</span>
                        </div>
                    </a-menu-item>
                    <a-sub-menu key="sub1" v-for="menu in screenMenus" :key="menu.path">
                        <span slot="title">
                            <div style="display: flex; align-items:center;">
                                <span class="anticon">
                                    <svg-icon :icon-class="menu.meta.icon" class="svg-icon_menu" />
                                </span>
                                <span>{{ menu.meta.name }}</span>
                            </div>
                        </span>
                        <a-menu-item v-for="subMenu in menu.children" :key="subMenu.path" @click="onBigScreenMenuTappped(subMenu)">
                            {{subMenu.meta.name}}
                        </a-menu-item>
                        <!--        <a-menu-item key="6">
                            Option 6
                        </a-menu-item>
                        <a-menu-item key="7">
                            Option 7
                        </a-menu-item>
                        <a-menu-item key="8">
                            Option 8
                        </a-menu-item> -->
                    </a-sub-menu>
                </a-menu>
            </div>
        </div>
		<div class="version-wrapper" :class="collapsed?'collapsed-version-wrapper':''"  @click="onShowVersion()">
		       版本号:{{currentVersion}}
		   </div>
    </a-layout-sider>
</template>
<script>
import config from '../../../../package.json'
import { getVersion } from "@/api/loginApi";

export default {
    components: {},
    name: 'Slider',
    data() {
        return {
            selectedKeys: [],
            menus: [],
            bottomMenus: [],
            screenMenus: [],
			configInfo:{},
			currentVersion: '',
			currentContent: '',
			
        }
    },
    computed: {
        collapsed() {
            return this.$store.state.menu.isCollapse
        }
    },
    created() {
		this.configInfo = config
        let routes = this.$router.options.routes


        this.menus = routes.filter((item) => {
            return item.meta.name.indexOf('大屏') < 0 && item.meta.name.indexOf('小屏') < 0 && item.meta.name.indexOf('系统') < 0
        })
        this.bottomMenus = routes.filter((item) => {
            return item.meta.name.indexOf('系统') > -1
        })
        this.screenMenus = routes.filter((item) => {
            return item.meta.name.indexOf('大屏') > -1 || item.meta.name.indexOf('小屏') > -1
        })
		getVersion().then((res) => {
            this.currentVersion = res.data.info.tagName
            this.currentContent = res.data.info.content

        }).catch((err) => {
                     
        })

        let bigScreenItem = this.screenMenus.find((item) => {
            return item.meta.name.indexOf('大屏') > -1
        })
        if (bigScreenItem) {
            let array = []
            console.log(bigScreenItem.children,'bigScreenItem.children');
            bigScreenItem.children.forEach((item) => {
                if (item.meta.name == '德圣米高') {
                    item.link = 'https://iot.shmashine.com/#/BigScreen_1'
                    array.push(item)
                } else if (item.meta.name == '瑞金医院') {
                    item.link = 'http://ruijin.bigsceen.shmashine.com/'
                    array.push(item)
                } else if (item.meta.name == '儿童医院') {
                    item.link = 'http://iot.shmashine.com:9550/'
                    array.push(item)
                } else if (item.meta.name == '通用大屏') {
                    item.link = 'https://wuye.web.shmashine.com/'
                    array.push(item)
                }else if (item.meta.name == "临港大屏") {
                    item.link = 'http://lingang.bigscreen.shmashine.com/'
                    array.push(item)
                }
                else if (item.meta.name == "服务器监控") {
                    item.link = 'http://grafana.tech.shmashine.com'
                    array.push(item)
                } 
            })
            bigScreenItem.children = array
        }
        let smallScreenItem = this.screenMenus.find((item) => {
            return item.meta.name.indexOf('小屏') > -1
        })
        if (smallScreenItem) {
            let array = []
            smallScreenItem.children.forEach((item) => {
                if (item.meta.name == '运维小屏') {
                    item.link = 'http://iot.shmashine.com:9537/eye'
                    array.push(item)
                } else if (item.meta.name == '服务监控') {
                    item.link = 'http://iot.shmashine.com:9530/'
                    array.push(item)
                }
            })
            smallScreenItem.children = array
        }

    },
    destroyed() {},
    methods: {
        onMenuTappped(menu) {
            this.$emit('selectMenu', menu)
        },
		onShowVersion(menu) {
			this.$Modal.warning({
			   title: "版本号",
			   content: '当前版本号：'+this.currentVersion+' <br> 更新内容：'+this.currentContent,
			   okText: "确认",
			   closable: true
			});
		   
		},
        onBigScreenMenuTappped(menu) {
            this.$emit('selectBigScreenMenu', menu)
        }
    },
    watch: {
        "selectMenuKey": {
            immediate: true,
            handler(val) {
                this.selectedKeys = [val]
            },
        },

        // collapsed: function(newVal, oldVal) {
        //     this.test = newVal
        // }
    },
    // props: ["collapsed", "selectMenuKey"]
    props: ["selectMenuKey"]
}
</script>
<style lang="scss" scoped>
.sider {
    overflow: hidden;
    padding: 15px 0;
}

.menu-wrapper {
    display: flex;
    flex-direction: column;
    height: calc(100% - 30px);
}

.top-menu {
    flex: 1;
}


::v-deep .ant-menu-vertical .ant-menu-item {
    padding: 0 26px;
    margin: 0;
    height: 48px;
    line-height: 48px;
}

::v-deep .ant-menu-vertical>.ant-menu-item {
    font-size: 16px;
}

::v-deep .ant-menu-item-active {
    color: #fff !important;
    background-color: rgba(255, 255, 255, 0.28);
}

::v-deep .ant-menu-submenu-active {
    color: #fff !important;
    background-color: rgba(255, 255, 255, 0.28);
}

::v-deep .ant-menu-item-selected {
    background-color: #fff !important;
    color: #38A9E1 !important;
}

::v-deep .ant-menu-item {
    color: #fff;
    font-size:14px!important;
}

::v-deep .ant-menu-submenu-arrow {
    display: none;
}

::v-deep .ant-menu-submenu-title {
    padding: 0 26px !important;
    color: #fff !important;
}

::v-deep .ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
    border-right: none !important;
    // padding: 0 29px;
}

::v-deep .ant-menu-inline .ant-menu-item::after {
    border-right: 0;
}

.anticon {
    line-height: 0 !important;
}

.version-wrapper {
	margin-top: 10px;
    text-align:center;
    color:#fff;
    font-size:14px;
}

.collapsed-version-wrapper {
	margin-top: 10px;
    font-size:12px;
}
</style>